<template>
  <div class="table-header-cell-dropdown">
    <div @click.prevent="isOpen = true"
         class="table-header-cell-dropdown__trigger-wrap">
      <button type="button" class="table-header-cell-dropdown__trigger">
        <span>
          <slot name="trigger-text">
            <!-- TRIGGER TEXT -->
          </slot>
        </span>
        <slot name="trigger-ico">
          <!-- TRIGGER ICO -->
          <BaseSvg class="table-header-cell-dropdown__trigger-arrow"
                   name="ico-arrow"/>
        </slot>
      </button>
      <div v-if="$slots.selected"
           class="table-header-cell-dropdown__selected">
        <slot name="selected">
          <!-- SELECTED -->
        </slot>
        <span @click.prevent.stop="$emit('clear')"
              class="table-header-cell-dropdown__selected-del">
          <BaseSvg name="ico-close"/>
        </span>
      </div>
    </div>

    <transition name="dropdown">
      <div v-if="isOpen"
           v-click-out="onClose"
           class="table-header-cell-dropdown__dropdown">
        <button type="button"
                class="table-header-cell-dropdown__close"
                @click.prevent="onClose">
          <BaseSvg name="ico-close"
                   width=".8rem"
                   height=".8rem"/>
        </button>

        <slot name="content">
          <!-- CONTENT -->
        </slot>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'TableHeaderCellDropdown',
    data() {
      return {
        isOpen: false,
      }
    },
    methods: {
      onClose() {
        this.isOpen = false
      },
    },
    watch: {
      isOpen(value) {
        if (value) {
          this.$emit('open')
        } else {
          this.$emit('close')
        }
      }
    }
  }
</script>

<style lang="less">

</style>
